// removed by extract-text-webpack-plugin
module.exports = {"root":"other-multiplier--root--1TBoJsr1 home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","label":"other-multiplier--label--AQGLYnW7","input":"other-multiplier--input--2ORmhsqS","reminder":"other-multiplier--reminder--3KYiZGLC"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/other-multiplier/styles.css
// module id = ./views/refunds/other-multiplier/styles.css
// module chunks = 0